// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"05c531ca","232":"67a6d295","348":"56e98c91","378":"0a1b973e","391":"86ed43f1","516":"30d8b360","667":"2c576d7b","787":"b363f5e5","826":"49d3653c","872":"f6382b9d"}[chunkId] + ".chunk.js";
};